
<template>
  <div class="columns is-centered">
    <div class="column is-two-thirds-tablet is-half-desktop">
      <p v-if="isLoading">{{ $t('email_confirmation.confirmation_in_progress') }}</p>
      <div class="message is-small is-success animated fast fadeIn" v-if="emailConfirmed">
        <div class="message-body">
          {{ $t('email_confirmation.email_verified') }}
          <span v-if="nextStep">
            {{ nextStep }}
          </span>
        </div>
      </div>
      <div class="message is-small is-danger animated fast fadeIn" v-if="errorMessage">
        <div class="message-body">{{ $t(errorMessage) }}</div>
      </div>
      <div v-if="emailConfirmed || errorMessage" class="login-container">
        <gradient-button
          :title="$t('email_confirmation.login')"
          :is-inline="true"
          @click.native="signin()"
        >
        </gradient-button>
      </div>
    </div>
  </div>
</template>

<script>
import Auth from "services/Auth";
import { GradientButton } from "components/buttons";

export default {
  data() {
    return {
      emailConfirmed: false,
      errorMessage: "",
      isLoading: false,
      nextStep: '',
    };
  },
  components: {
    GradientButton
  },
  mounted() {
    this.confirmEmail();
  },
  methods: {
    signin() {
      this.$router.push('/')
    },
    confirmEmail() {
      if (this.isLoading) {
        return;
      }

      this.isLoading = true;
      this.errorMessage = "";

      return Auth.confirmEmail(this.confirmationCode)
        .then((data) => {
          this.emailConfirmed = true;
        })
        .catch(err => {
          if (err.message === 'WAIT_FOR_JOURNEYS_SIGNUP_APPROVAL') {
            this.emailConfirmed = true;
            this.nextStep = 'Your account is under review. We will let you know once your account is approved.';
          } else {
            this.errorMessage = err.message || "email_confirmation.errors.confirmation_failed";
            this.emailConfirmed = false;
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  },

  computed: {
    confirmationCode() {
      return this.$route.params.code
    }
  }
};
</script>

<style lang="scss" scoped>
.login-container {
  margin: 1rem 0;
  text-align: center;
}
</style>
